import React, { FC, useEffect, useState } from 'react';
import { PageWrapper, useShowAlertPopup, ProductForm, Product, useShowConfirmationPopup } from '@dew21/ui';
import axios from 'axios';
import { useHistory, useParams } from 'react-router';

export const EditProduct: FC = (props) => {
  const { id } = useParams();
  const [product, setProduct] = useState<Product | null>(null);
  const history = useHistory();
  const showNotificationBanner = useShowAlertPopup();
  const showConfirmationPopup = useShowConfirmationPopup();

  const fetchProduct = () => {
    return axios.get(`/api/product/${id}`);
  };

  useEffect(() => {
    fetchProduct().then((response) => {
      setProduct(response.data);
    }).catch((error) => {
      setProduct(null);
    });
  }, []);

  return <PageWrapper
    breadCrumb={[{ title: 'Produkte', path: '/products' }, {
      title: 'Bearbeiten',
      path: `/products/${id}`,
    }]}
    marginal={{
      items: [{
        text: 'Produkt löschen',
        icon: 'trash',
        actionFn: () => {
          showConfirmationPopup({
            open: true,
            actionButtonLabel: 'Löschen',
            closeFn() {
              showConfirmationPopup(null);
            },
            actionFn() {
              axios.delete(`/api/product/${id}`).then((response) => {
                history.push('/products/');
                showConfirmationPopup(null);
                showNotificationBanner({
                  renderContent: () => {
                    return <>Das Produkt wurde gelöscht.</>;
                  },
                });
              }).catch((e) => {
                showNotificationBanner({
                  error: true, renderContent: () => {
                    return <>Das Produkt konnte nicht gelöscht werden.</>;
                  },
                });
                showConfirmationPopup(null);
              });
            },
            renderer() {
              return <>Wollen Sie das Produkt wirklick löschen?</>;
            },
          });
        },
      }],
    }}>
    <ProductForm
      onCancel={() => {
        history.push('/products');
      }}
      product={product}
      setProduct={(payload) => {
        const data = {
          product: payload.product,
          attachments: payload.attachments ? payload.attachments : null,
        };
        axios.put(`/api/product/${id}`, data).then((response) => {
          setProduct(response.data);
          showNotificationBanner({ renderContent: () => <>Das Produkt wurde gespeichert.</> });
          history.push('/products');
        }).catch((error) => {
          console.log(error);
        });
      }}/>
  </PageWrapper>;
};
